<h2 mat-dialog-title>{{ data?.title }}</h2>
<mat-dialog-content>
  @if (!data.hideAddress) {
    @for (field of data.fields; track field; let i = $index) {
      @if (field.head) {
        <h6>{{ field.head }}</h6>
      }
      <div class="radio-wrapper">
        <label>
          <input
            id="dialog-form-address-{{i+1}}-input"
            [hidden]="data?.isRadio"
            name="address"
            [checked]="selectedAddress === i"
            [value]="i"
            type="radio"
            [(ngModel)]="selectedAddress" />
          <span [innerHTML]="field.label"></span
          ></label>
        </div>
      }
    }
    @if (data.errorMessage) {
      <br />
    }
    @if (data.errorMessage) {
      <p style="color: orange">
        {{ data.errorMessage }}
      </p>
    }
    <br />
    @if (data?.withoutValidation) {
      <p>
        We were unable to verify your address with FedEx. Please verify that you
        entered a residential address.
        <br />
        <br />
        Need help? Email
        <a href="mailto:contact&#64;playoctopus.com">contact&#64;playoctopus.com</a>
        <br />
        <br />
        Click “Continue” to proceed with the entered address or “Back” to change
        the address entered.
      </p>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button class="btn btn-pink" (click)="close()" id="dialog-form-back-button">Back</button>
    @if (data?.hasSuggestions && !data?.withoutValidation) {
      <button
        mat-button
        class="btn btn-pink"
        (click)="submitAddress()"
        id="dialog-form-submit-button"
        >
        Submit
      </button>
    }
    @if (data?.withoutValidation) {
      <button
        mat-button
        class="btn btn-pink"
        (click)="continueWithoutValidation()"
        id="dialog-form-continue-button"
        >
        Continue
      </button>
    }
  </mat-dialog-actions>
